import {
    FieldInCard,
} from 'app/types/form.types'
import {
    SizeLink, TypeLink,
} from 'app/shared-components/SkyNetLink'
import {
    ContainerStatus,
} from 'app/enums/label.enums'
import {
    OverviewFields,
} from './Overview.types'

const getFields = (
    getAllowedValues: (val: Record<string, string>) => Record<string, string>,
    longTermLeaseLink: string,
): FieldInCard<OverviewFields>[] => {
    return [{
        title: 'Summary',
        fields: [
            {
                name: 'serialNumber',
                componentName: 'InputSingleline',
                labelKey: 'Container.serialNumber',
            },
            {
                name: 'containerStatus',
                componentName: 'EnumSelector',
                allowedValues: getAllowedValues(ContainerStatus),
                labelKey: 'Container.containerStatus',
            },
            {
                name: 'jypId',
                componentName: 'InputSingleline',
                labelKey: 'Container.jypId',
            },
            {
                name: 'containerDescription',
                componentName: 'InputSingleline',
                labelKey: 'Container.containerDescription',
            },
            {
                name: 'location',
                labelKey: 'Container.location',
                componentName: 'LocationObjectSelector',
            },
            {
                name: 'containerModel',
                componentName: 'IntegerInput',
                labelKey: 'ContainerType.containerModel',
            },
            {
                name: 'currentLongTermLeaseNumber',
                componentName: 'SkyNetLink',
                link: longTermLeaseLink,
                type: TypeLink.EXTERNAL,
                size: SizeLink.S,
                labelKey: 'Container.currentLongTermLeaseNumber',
            },
        ],
    }]
}

export default getFields
